import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - MENU ||============================== //

export default function Menu(theme: Theme) {
  const paperBase = {
    backgroundImage: `${theme.customGradients.paperBg} !important`,
    backgroundColor: `${theme.palette.mode === 'dark' ? 'rgba(10,10,26,0.92)' : theme.palette.background.paper} !important`,
    backdropFilter: 'blur(10px) saturate(120%)',
    WebkitBackdropFilter: 'blur(10px) saturate(120%)',
    color: `${theme.palette.text.primary} !important`,
    boxShadow: '0 8px 32px rgba(0,0,0,0.35)'
  };

  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          ...paperBase,
          '& .MuiList-root': {
            color: `${theme.palette.text.primary} !important`,
            background: 'transparent',
            border: '1px solid rgba(255,255,255,.08)',
          }
        }
      }
    }
  };
}

